import cdProfileCookie from '../../smartpak/smartpak.cdprofilecookie';
import { read } from '../../smartpak/cookie';

function getCustomerToken() {
    const cookie = read('EQCookie'),
        token = cookie ? cookie.split('=')[1] : '';
    return token;
}

export function customer() {
    const token = getCustomerToken();

    if (token) {
        push({
            'customerIP': read('RequestIP') ?? '',
            'customerWebToken': getCustomerToken(),
            'customerEmail': cdProfileCookie.CustomerEmail,
            'customerHashedEmail': cdProfileCookie.CustomerHashedEmail,
            'customerFirstName': cdProfileCookie.CustomerFirstName,
        });
    }
}

export function cdProfileProperties(cdProfileCookie) {
    const { Disciplines, HasActiveSubscription, IsTaxExempt } = cdProfileCookie;
    const disciplines = Disciplines || '';
    // eslint-disable-next-line no-extra-boolean-cast
    const split = !!disciplines ? disciplines.split(',') : [];

    push({
        hasDisciplineBarrelRacingGymkhana: /Barrel Racing\/Gymkhana/gi.test(disciplines),
        hasDisciplineCutting: /Cutting/gi.test(disciplines),
        hasDisciplineDressage: /Dressage/gi.test(disciplines),
        hasDisciplineDriving: /Driving/gi.test(disciplines),
        hasDisciplineEndurance: /Endurance/gi.test(disciplines),
        hasDisciplineEnglishTrailRiding: /English Trail Riding/gi.test(disciplines),
        hasDisciplineEventing: /Eventing/gi.test(disciplines),
        hasDisciplineHunterJumper: /Hunter\/Jumper/gi.test(disciplines),
        hasDisciplineOtherEnglishStyle: /Other English Style/gi.test(disciplines),
        hasDisciplineOtherWesternStyle: /Other Western Style/gi.test(disciplines),
        hasDisciplinePolo: /Polo/gi.test(disciplines),
        hasDisciplineRacing: split.includes('Racing'),
        hasDisciplineReining: /Reining/gi.test(disciplines),
        hasDisciplineRodeoEvents: /Rodeo Events/gi.test(disciplines),
        hasDisciplineSaddleSeat: /Saddle Seat/gi.test(disciplines),
        hasDisciplineWesternAllAround: /Western All Around/gi.test(disciplines),
        hasDisciplineWesternTrailRiding: /Western Trail Riding/gi.test(disciplines),
        hasDisciplineMultiple: split.length > 0,
        hasActiveSubscription: HasActiveSubscription || false,
        isTaxExempt: IsTaxExempt || false
    });
}



function push(obj) {
    window.dataLayer = window['dataLayer'] || [];
    window.dataLayer.push(obj);
}